import { useAppStore } from "@/store";
import { useEffect } from "react";
import { FeatureGateBannerQuotaLevel } from "./feature-gate-banner.types";
import { FeatureGateBannerDisplay } from "@/components/banners/feature-gate-banner";
import { observer } from "mobx-react-lite";

export const FeatureGateBanner = observer(function FeatureGateBanner() {
  const { store } = useAppStore();
  const featureGates = store.featureGates;

  useEffect(() => {
    featureGates?.refreshUpsellBanner();
  }, [featureGates]);

  if (!featureGates?.upsellBannerVisible) return null;

  return (
    <FeatureGateBannerDisplay
      level={
        featureGates?.upsellBannerExceeded
          ? FeatureGateBannerQuotaLevel.Exceeded
          : FeatureGateBannerQuotaLevel.Warning
      }
    />
  );
});
